import { render, staticRenderFns } from "./certifiedGame.vue?vue&type=template&id=16ce999c&"
import script from "./certifiedGame.vue?vue&type=script&lang=js&"
export * from "./certifiedGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports